import { createContext, ReactNode, useContext, useState } from 'react';
import { RatesParams } from 'api/rates/rates.types';
import { DEFAULT_PARAMS } from './ratesContext.const';

export const useProvideRatesContext = () => {
  const [params, setParams] = useState<RatesParams>(DEFAULT_PARAMS);

  const getTabParams = () => params;

  const getSetTabParams = () => setParams;

  return {
    getTabParams,
    getSetTabParams,
  };
};

const ratesContext = createContext<
  ReturnType<typeof useProvideRatesContext> | undefined
>(undefined);

export const useRatesContext = () => {
  const context = useContext(ratesContext);

  if (context === undefined) {
    throw new Error('useRatesContext must be used within a RatesProvider');
  }

  return context;
};

export const RatesContextProvider = ({ children }: { children: ReactNode }) => {
  const auth = useProvideRatesContext();
  return <ratesContext.Provider value={auth}>{children}</ratesContext.Provider>;
};
